/* eslint-disable react/jsx-indent */
/* eslint-disable react/no-unused-prop-types */
import React, {
  useCallback, useMemo, useState, memo,
} from 'react';
import styled from 'styled-components';
import { CompanyPersonality } from 'Types/CompaniesTypes';
import { Pulse } from 'Types/PulseTypes';
import { colorGradientsWithoutMix, isXiqUser } from 'Utils/UtilityFunctions';
import DrawerPeopleMoveReason from 'Components/people/components/DrawerPeopleMoveReason';
import classNames from 'classnames';
import { Tooltip, Dropdown } from 'antd';
import { COMPANY_OVERVIEW_ROUTE } from 'Utils/Constants';
import { useNavigate } from 'react-router-dom';
import { actions } from 'Slice/CompaniesSlice';
import { useDispatch } from 'react-redux';
import HeatMapProgress from './HeatMapProgress';
import {
  SecondaryColor,
  maxMobile,
  maxTablet,
  maxWidth, maxWidth1170, minExtraLargeScreen, minWidthApp, primaryColor, primaryFont,
  retina, wMedium,
} from '../../../Utils/utilsStyle';
import SmartPlanSvg from '../assets/svgIcons/SmartPlanSvg';

type Props = {
  persona: CompanyPersonality[],
  logo: string,
  triggerColor: Pulse[],
  width?: string,
  height?: string,
  widthSm?: string,
  heightSm?: string,
  widthXsm?: string,
  heightXsm?: string,
  widthXxsm?: string,
  heightXxsm?: string,
  imagePosition?: string,
  imagePositionSm?: string,
  imageSize?: string,
  title?: string,
  imageSizeSm?: string,
  classWrapper?: string
  showDrawerIcon?: boolean,
  removeButton?: boolean,
  id?: number,
  handleCardClicked: (id: number) => void,
  handleImageClick?: (id: number) => void,
  showSapIcon?: boolean,
  listView?: boolean,
  inGlobalSearch?: boolean,
  selectionCheckbox?: React.ReactNode,
} & typeof defaultProps;

const defaultProps = {
  width: '210px',
  height: '130px',
  widthSm: '110px',
  heightSm: '65px',
  widthXsm: '105px',
  heightXsm: '65px',
  widthXxsm: '100%',
  heightXxsm: '100px',
  imagePosition: '55px 25px',
  imagePositionSm: '50% 0px',
  imageSize: '50% 62%',
  title: '',
  imageSizeSm: '50%',
  classWrapper: '',
  showDrawerIcon: false,
  removeButton: false,
  id: 0,
  showSapIcon: false,
  listView: false,
  inGlobalSearch: false,
  selectionCheckbox: null as React.ReactNode,
  handleImageClick(a: number) { },
};

const Wrapper = styled.div<{
  color: string, width: string, height: string, widthSm: string, heightSm: string,
  widthXsm: string, heightXsm: string, heightXxsm: string, widthXxsm: string, removeButton: boolean,
  hasSelectionCheckbox: boolean,
}>`
position: relative;
.selection-checkbox {
  position: absolute;
  top: -9px;
  right: -9px;
  line-height: 0;
  z-index: 3;
  .ant-checkbox-inner {
    width: 24px;
    height: 24px;
    border: 2px solid #C1C1C1;
    @media all and (max-width: ${maxWidth1170}) {
      height: 22px;
      width: 22px;
    }
  }
  .ant-checkbox-checked .ant-checkbox-inner {
    border: 2px solid ${primaryColor};
  }
}
.drawer-btn-action {
  position: absolute;
  top:  ${(props) => (props.removeButton || props.hasSelectionCheckbox ? '20px' : '-8px')};
  right: -10px;
  .messageIcon {
    svg {
      height: 13px !important;
      margin: 0px !important;
    }
  }
}
 width: ${(props) => props.width};
 height: ${(props) => props.height};
 border-radius: 13px;
 padding: 5px;
 background:conic-gradient(from -70deg, ${(props) => props.color});
 background-color: ${(props) => props.color};
 position:relative;
 margin: 0px 0px 25px 0px;
  @media all and (max-width: ${maxWidth}) , ${retina} {
    width: ${(props) => props.widthSm};
    height: ${(props) => props.heightSm};
    border-radius: 11px;
    padding: 3px;
    margin: 0px 0px 10px 0px;
  }

  @media all and (max-width: ${minWidthApp}){
    width: ${(props) => props.widthXsm};
    height: ${(props) => props.heightXsm};
    margin: 0 auto 10px;
  }

  @media all and (max-width: ${maxTablet}) {
    width: ${(props) => props.widthXxsm};
    height: ${(props) => props.heightXxsm};
  }
 
  &.showSmallInXs {
    @media all and (max-width: ${maxMobile}){
      width: ${(props) => props.widthSm};
      height: ${(props) => props.heightSm};
    }
  }

  &:hover {
    + .company-title {
      visibility: visible;
    }
  }
  .progress-wrapper{
    padding: 0px 10px;
    position: absolute;
    bottom: 15px;
    width: 95%;
    div {
      height:4px;
    }
    @media all and (max-width: ${minWidthApp}){
      bottom: 10px;
    }
  }
  &.company-image-parent {
    .logo-image-wrapper {
     cursor: pointer;
     height: 100%;
     width: 100%;
     border-radius: 8px;
     text-align: center;
     background-color: #fff;
    }
    .company-img {
      height: 75%;
      width: auto;
      margin: auto;
      text-align: center;
      border-radius: 8px;
    }
    .smart-account-plan-history-icon {
      &.noNotes {
        top:  ${(props) => (props.removeButton || props.hasSelectionCheckbox ? '20px' : '-8px')};
      }
      display: flex;
      align-items: center;
      justify-content: center;
      height: 26px;
      width: 26px;
      border-radius: 50%;
      background-color: ${SecondaryColor};
      position: absolute;
      right: -10px;
      top: ${(props) => (props.removeButton || props.hasSelectionCheckbox ? '51px' : '22px')};
      cursor: pointer;
      svg {
        height: 14px;
        margin: 0px;
      }
      @media all and (max-width: ${maxWidth1170}) {
        height: 22px;
        width: 22px;
      }
    }
  }
&.companySearchWidget {
  margin: 0px 0px 6px 0px;
  @media all and (max-width: ${maxWidth}), ${retina} {
    width: ${(props) => props.widthSm};
    height: 92px; 
  }
  @media all and (max-width: ${minWidthApp}){
    width: ${(props) => props.widthSm};
    height: ${(props) => props.heightSm};
    margin: 0 auto 10px;
  }
  &.showSmallInXs {
    @media all and (max-width: ${maxMobile}){
      width: ${(props) => props.widthSm};
      height: 92px;
    }
  }
}
&.companyListSearchWidget {
  border-radius: 6px;
  margin:0px;
  padding: 2px;
  @media all and (min-width: ${minExtraLargeScreen}) {
    width: 62px;
    height: 54px;
    border-radius: 6px;
  }
  @media all and (max-width: ${maxWidth}), ${retina} {
    border-radius: 4px;
  }
  @media all and (max-width: ${maxTablet}) {
    border-radius: 3px;
  }
  @media all and (max-width: ${maxMobile}) {
    width: 34px;
    height: 30px;
    border-radius: 3px;
  }
  .logo-image-wrapper{
    border-radius: 4px;
    @media all and (min-width: ${minExtraLargeScreen}) {
      border-radius: 6px;
    }
    @media all and (max-width: ${maxWidth}) , ${retina} {
      border-radius: 2px;
    }
    @media all and (max-width: ${maxTablet}) {
      border-radius: 2px;
    }
    .company-img{
      margin: 3px auto;
      border-radius: 4px;
      @media all and (min-width: ${minExtraLargeScreen}) {
        border-radius: 6px;
      }
      @media all and (max-width: ${maxWidth}) , ${retina} {
        border-radius: 2px;
      }
      @media all and (max-width: ${maxTablet}) {
        border-radius: 2px;
        margin-bottom: 6px;
      }
    } 
  }

}
`;

const Heading = styled.h6`
  font-size: 14px;
  font-family: ${primaryFont};
  font-weight: ${wMedium};
  color: #7E7E7E;
  text-align: center;
  line-height: 26px;
  position: absolute;
  left: 50%;
  bottom: -7px;
  margin-bottom: 0px;
  transform: translateX(-50%);
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  visibility: hidden;
  @media all and (max-width: ${maxWidth}) , ${retina} {
    font-size:12px;
    bottom: -20px;
  }
  @media all and (max-width: ${minWidthApp}) {
    display: none;
  }
`;

const CompanyWidgetLarge = function CompanyWidgetLarge(props: Props) {
  const {
    persona,
    logo,
    triggerColor,
    width,
    height,
    widthSm,
    heightSm,
    heightXsm,
    widthXsm,
    heightXxsm,
    widthXxsm,
    title,
    classWrapper,
    showDrawerIcon,
    id,
    showSapIcon,
    removeButton,
    handleCardClicked,
    handleImageClick,
    listView,
    inGlobalSearch,
    selectionCheckbox,
  } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isDropdownVisible, setIsDropdownVisible] = useState(false);

  const colors = useMemo(
    () => (persona.length > 0 ? (colorGradientsWithoutMix(persona) || '') : ''),
    [persona],
  );

  const handleRightClick = useCallback((e: React.MouseEvent<HTMLSpanElement> |
    React.KeyboardEvent<HTMLSpanElement>) => {
    e.stopPropagation();
    handleCardClicked(id);
  }, [handleCardClicked, id]);

  const onOpenInNewTab = useCallback((e: React.MouseEvent<HTMLSpanElement> |
    React.KeyboardEvent<HTMLSpanElement>) => {
    setIsDropdownVisible(false);
    handleRightClick(e);
  }, [handleRightClick]);

  const items = useMemo(() => [
    {
      label:
        <span
          role="button"
          tabIndex={0}
          onClick={onOpenInNewTab}
          onKeyPress={onOpenInNewTab}
          aria-label="redirectCard"
        >
          Open in New Tab
        </span>,
      key: '1',
    },
  ], [onOpenInNewTab]);

  const handleAccountPlanClick = useCallback(() => {
    dispatch(actions.resetAccountPlan());
    dispatch(actions.setShowSAPHistory(true));
    dispatch(actions.setShowCreateNew(false));
    dispatch(actions.setShowPodcastTab(false));
    navigate(`${COMPANY_OVERVIEW_ROUTE}${id}&accountPlan=true`);
  }, [dispatch, navigate, id]);

  const handleWidgetClick = useCallback(() => {
    if (!isXiqUser()) return;
    setIsDropdownVisible((prev) => !prev);
  }, []);

  const handleLogoImageActivate = useCallback(() => {
    handleImageClick(id);
  }, [handleImageClick, id]);

  return (
    <>
      <Wrapper
        color={colors}
        width={width}
        height={height}
        widthSm={widthSm}
        heightSm={heightSm}
        heightXsm={heightXsm}
        widthXsm={widthXsm}
        widthXxsm={widthXxsm}
        heightXxsm={heightXxsm}
        removeButton={removeButton}
        hasSelectionCheckbox={!!selectionCheckbox}
        className={classNames(`company-image-parent ${classWrapper}`, {
          companySearchWidget: inGlobalSearch && !listView,
          companyListSearchWidget: inGlobalSearch && listView,
        })}
      >
        <Dropdown
          menu={{ items }}
          trigger={['contextMenu']}
          visible={isDropdownVisible}
          onOpenChange={handleWidgetClick}
        >
          <div
            className="logo-image-wrapper"
            onClick={handleLogoImageActivate}
            onKeyDown={handleLogoImageActivate}
            tabIndex={0}
            role="button"
          >
            <img
              src={logo}
              alt="company-logo"
              className="company-img img-fluid"
              loading={inGlobalSearch || listView ? 'lazy' : 'eager'}
              decoding="async"
            />
          </div>
        </Dropdown>
        {selectionCheckbox ? (
          <span
            className="selection-checkbox"
            role="presentation"
            onClick={(e) => e.stopPropagation()}
            onKeyDown={(e) => e.stopPropagation()}
          >
            {selectionCheckbox}
          </span>
        ) : null}
        {showSapIcon
          ? (
            <Tooltip
              placement="top"
              // getPopupContainer={(e: HTMLElement) => e}
              className="triggers-bullet-tooltip smartHistoryTip"
              color="#fff"
              title="View already created Smart Account Plans"
              arrow={false}
            >
              <div
                className={classNames('smart-account-plan-history-icon', { noNotes: !showDrawerIcon })}
                role="button"
                onClick={(e) => { e.stopPropagation(); handleAccountPlanClick(); }}
                onKeyDown={(e) => e.stopPropagation()}
                tabIndex={0}
                aria-label="account-plan-open"
              >
                <SmartPlanSvg color="#fff" />
              </div>
            </Tooltip>
          ) : null}
        {showDrawerIcon && (
          <div role="button" onClick={(e) => e.stopPropagation()} onKeyDown={(e) => e.stopPropagation()} tabIndex={0} aria-label="show-drawer">
            <DrawerPeopleMoveReason companyId={id} showNotes isCompanyNotes />
          </div>
        )}
        {!listView ? (
          <HeatMapProgress pulse={triggerColor} />
        ) : (<> </>)}
        {/* <HeatMapProgress pulse={triggerColor} /> */}
      </Wrapper>
      {title && <Heading className="company-title">{title}</Heading>}
    </>
  );
};

CompanyWidgetLarge.defaultProps = defaultProps;

export default memo(CompanyWidgetLarge);
